<div class="row p-0 m-0 d-flex justify-content-center top20">
    <div class="tr-login-fb col-md-12 col-10 text-center position-relative d-flex align-items-center justify-content-center" (click)="loginwithFacebook()"> 
            <img src="/assets/icons/fb-logo.svg" class="position-sm-absolute" alt=""> <span> Register with Facebook</span>
    </div>
    <div class="tr-login-google col-md-12 col-md-10 col-10 text-center mt-3 position-relative d-flex align-items-center justify-content-center" (click)="loginWithGoogle()">
        <img src="/assets/icons/google-logo.svg" class="position-sm-absolute" alt=""> <span> Register with Google</span>
    </div>
</div>